import { UseCaseForm } from "helpers/hooks/useCaseForm";
import { createContext } from "react";

export const CaseFormContext = createContext<UseCaseForm>(null!);
